import React from 'react';
import { PageHeader } from '@/components/common/PageHeader';
import { Card, CardContent } from '@/components/ui/card';

const TermsPage = () => {
  return (
    <div>
      <PageHeader
        title="Terms & Conditions"
        subtitle="Terms of service for students and parents"
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'Terms & Conditions' }
        ]}
      />

      <section className="section-padding bg-background">
        <div className="container-custom max-w-4xl">
          <Card>
            <CardContent className="p-8 prose prose-lg max-w-none">
              <p className="text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">1. Admission and Enrollment</h3>
              <p className="text-foreground leading-relaxed mb-4">
                Admission to Mantra Prayas Institute is subject to availability of seats and fulfillment of eligibility criteria. The institute reserves the right to accept or reject any application without assigning any reason.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">2. Fee Structure and Payment</h3>
              <ul className="list-disc pl-6 text-foreground space-y-2 mb-4">
                <li>Course fees must be paid as per the payment schedule provided</li>
                <li>Fees once paid are non-refundable except as per the refund policy</li>
                <li>Late payment may result in additional charges</li>
                <li>Scholarships and discounts are subject to terms and conditions</li>
              </ul>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">3. Attendance and Discipline</h3>
              <p className="text-foreground leading-relaxed mb-4">
                Students are expected to maintain at least 75% attendance. Regular attendance is crucial for academic success. Students must adhere to the code of conduct and disciplinary rules of the institute.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">4. Study Material and Resources</h3>
              <p className="text-foreground leading-relaxed mb-4">
                Study materials provided by the institute are for personal use only and should not be reproduced or distributed without permission. All intellectual property rights are reserved by the institute.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">5. Tests and Assessments</h3>
              <p className="text-foreground leading-relaxed mb-4">
                Students must appear for regular tests and assessments. Missing tests without valid reasons may affect performance evaluation. Re-tests are subject to approval and may incur additional charges.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">6. Termination of Services</h3>
              <p className="text-foreground leading-relaxed mb-4">
                The institute reserves the right to terminate services in case of:
              </p>
              <ul className="list-disc pl-6 text-foreground space-y-2 mb-4">
                <li>Violation of code of conduct</li>
                <li>Non-payment of fees</li>
                <li>Providing false information during admission</li>
                <li>Any misconduct or indiscipline</li>
              </ul>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">7. Liability Disclaimer</h3>
              <p className="text-foreground leading-relaxed mb-4">
                While we strive to provide the best education and guidance, Mantra Prayas Institute does not guarantee specific results or ranks in competitive examinations. Student success depends on individual effort, dedication, and various other factors.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">8. Changes to Terms</h3>
              <p className="text-foreground leading-relaxed mb-4">
                We reserve the right to modify these terms and conditions at any time. Students and parents will be notified of significant changes through email or notice board.
              </p>

              <h3 className="text-xl font-heading font-bold text-foreground mt-8 mb-4">9. Contact Information</h3>
              <p className="text-foreground leading-relaxed mb-4">
                For any queries regarding these terms and conditions, please contact:
              </p>
              <ul className="list-none text-foreground space-y-1">
                <li>Email: info@mantraprayas.com</li>
                <li>Phone: +91 98765 43210</li>
                <li>Address: Plot No. 45, Sector 12, Bhilwara, Rajasthan - 311001</li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
